export { default as PatientDataModal } from './PatientDataModal';
